import { Fragment, FC } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import truncate from 'lodash.truncate';

// components
import { PdpSharedDealerDetailsBioModalLazy } from './PdpSharedDealerDetailsBioModalLazy';

// types
import { PdpSharedDealerDetailsBio_seller as Seller } from './__generated__/PdpSharedDealerDetailsBio_seller.graphql';

// styles
import styles from './PdpSharedDealerDetailsBio.scss';

const DEFAULT_MAX_CHAR_LENGTH = 340;

type Props = {
    seller: Seller;
    isClient: boolean;
    maxCharLength?: number;
};

const PdpSharedDealerDetailsBioComponent: FC<Props> = ({ seller, isClient, maxCharLength }) => {
    const { isRewardsTier2, liveStorefrontProfile } = seller || {};

    if (!liveStorefrontProfile || !isRewardsTier2) {
        return null;
    }

    const { aboutUsUnbranded: aboutUs } = liveStorefrontProfile;

    return (
        <Fragment>
            {aboutUs && (
                <div className={styles.container}>
                    <span className={styles.textContainer}>
                        <p>
                            {truncate(aboutUs, {
                                length: maxCharLength || DEFAULT_MAX_CHAR_LENGTH,
                            })}
                        </p>
                        {isClient && (
                            <PdpSharedDealerDetailsBioModalLazy
                                seller={seller}
                                linkClass={styles.readMore}
                            />
                        )}
                    </span>
                </div>
            )}
        </Fragment>
    );
};

export const PdpSharedDealerDetailsBio = createFragmentContainer(
    PdpSharedDealerDetailsBioComponent,
    {
        seller: graphql`
            fragment PdpSharedDealerDetailsBio_seller on Seller {
                serviceId
                isRewardsTier2: isAnchorListMember(listName: "SELLER_REWARDS_2")
                liveStorefrontProfile {
                    aboutUsUnbranded
                }
                ...PdpSharedDealerDetailsBioModalLazy_seller
            }
        `,
    }
);
